import { PermissionType } from 'domain/_entities/permission.entity'
import { RouteDefs } from 'routes/_utils/transform_routes/transform.routes'

const PROJECT_LAYOUT = () =>
  import('presentation/projects/layout/project_layout')
const PROJECT_OVERVIEW = () =>
  import('presentation/projects/project_overview/project_overview')
const PROJECT_CALENDAR = () => import('presentation/calendar/calendar_page')
const PROJECT_ORDER_LIST = () =>
  import('presentation/project_order_lists/order_lists/order-list.view')
const PROJECT_DELIVERIES = () =>
  import('presentation/deliveries/delivery_list/delivery_list.view')
const PROJECT_EVALUATIONS = () =>
  import('presentation/mass_balances/component_overview.view')
const COMPONENT_OVERVIEW = () =>
  import('presentation/mass_balances/component_overview.view')
const PRODUCT_LIST = () =>
  import('presentation/deliveries/product_list/product_list_page')
const CONCRETE = () =>
  import('presentation/deliveries/concrete_view/concrete_view')
const INVOICES = () =>
  import('presentation/invoices/invoice_list/invoice_list.view')
const PURCHASE_ORDERS = () =>
  import('presentation/purchase_orders/purchase_orders')
const MANAGE_COMPONENTS = () =>
  import(
    'presentation/projects/project_settings/component_settings/manage_components'
  )
const UNLOADING_LOCATION = () =>
  import(
    'presentation/projects/project_settings/unloading-location/unloading-location.view'
  )
const WORK_TYPES = () =>
  import('presentation/projects/project_settings/work_type_settings/work_types')
const PROJECT_ROLES = () =>
  import('presentation/projects/project_roles/project_roles.view')
const PORTALS = () =>
  import('presentation/orders/order_portals/order_portals.view')

export const projectRouteDefs: RouteDefs[] = [
  {
    path: '/project/:project_id',
    file: PROJECT_LAYOUT,
    children: [
      {
        index: true,
        file: PROJECT_OVERVIEW,
      },
      {
        path: 'calendar',
        file: PROJECT_CALENDAR,
        permissions: [PermissionType.EDIT_ORDERS],
      },
      {
        path: 'orders',
        file: PROJECT_ORDER_LIST,
        permissions: [PermissionType.EDIT_ORDERS],
      },
      {
        path: 'portals',
        file: PORTALS,
        permissions: [PermissionType.EDIT_ORDERS],
        features: ['portal_ordering'],
      },
      {
        path: 'order-list',
        file: PROJECT_ORDER_LIST,
        permissions: [PermissionType.EDIT_ORDERS],
        features: ['iron-ordering'],
      },
      {
        path: 'deliveries',
        file: PROJECT_DELIVERIES,
        permissions: [PermissionType.EDIT_DELIVERIES],
      },
      {
        path: 'evaluations',
        file: PROJECT_EVALUATIONS,
      },
      {
        path: 'components-overview',
        file: COMPONENT_OVERVIEW,
        permissions: [PermissionType.EDIT_DELIVERIES],
        features: ['delivery-components'],
      },
      {
        path: 'product-list',
        file: PRODUCT_LIST,
        permissions: [PermissionType.EDIT_DELIVERIES],
      },
      {
        path: 'concrete',
        file: CONCRETE,
        permissions: [PermissionType.EDIT_DELIVERIES],
        features: ['concrete'],
      },
      {
        path: 'invoices',
        file: INVOICES,
        permissions: [PermissionType.EDIT_INVOICES],
        features: ['invoices'],
      },
      {
        path: 'project-settings',
        file: PURCHASE_ORDERS,
        permissions: [PermissionType.EDIT_PROJECT_SUPPLIER],
      },
      {
        path: 'suppliers',
        file: PURCHASE_ORDERS,
        permissions: [PermissionType.EDIT_PROJECT_SUPPLIER],
      },
      {
        path: 'project-components',
        file: MANAGE_COMPONENTS,
        permissions: [PermissionType.EDIT_PROJECT_SETTINGS],
      },
      {
        path: 'unloading-location',
        file: UNLOADING_LOCATION,
        permissions: [PermissionType.EDIT_PROJECT_SETTINGS],
      },
      {
        path: 'work-types',
        file: WORK_TYPES,
        permissions: [PermissionType.EDIT_PROJECT_SETTINGS],
        features: ['work_types'],
      },
      {
        path: 'permissions',
        file: PROJECT_ROLES,
        permissions: [
          PermissionType.EDIT_PROJECT_USERS,
          PermissionType.EDIT_PROJECT_SUPPLIER,
        ],
        features: ['project_permissions'],
      },
    ],
  },
]
